$ = require 'jquery'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PopOver = require 'app/scripts/views/lib/pop-over'
sandboxParams = require 'app/scripts/data/plugin-iframe-sandbox'
t = require('app/scripts/views/internal/teacup-with-helpers')()

template = t.renderable (content = {}) ->
  { url, height } = content
  t.iframe '.plugin-iframe',
    allow: 'microphone; camera'
    sandbox: sandboxParams
    src: url
    style: if height then "height:#{ height }px;" else undefined

  return

module.exports = class PluginPopOverIFrameView extends PluginView
  initialize: ({ @title, @content, @callback }) ->
    @retain(@callback)

  getViewTitle: -> @title

  keepInDOM: true

  vigor: @VIGOR.NONE

  renderOnce: ->
    @$el.html(template(@content))

    @initIFrames(@model)

    @

  handleIFrameMessage: (iframe, message) ->
    switch message
      when 'done'
        if @callback?
          return @callback({ el: iframe })
        else
          PopOver.hide()
          return
